<template>
  <transition name="zoom-in-top">
    <div
      v-if="multiple"
      v-show="showPopper"
      v-clickoutside="handleOutsideClick"
      :class="prefixTableClass+'-filter'"
    >
      <div :class="prefixTableClass+'-filter__content'">
        <t-scroll-spy :wrap-class="prefixTableClass+'-filter__wrap'">
          <t-checkbox-group v-model="filteredValue" :class="prefixTableClass+'-filter__checkbox-group'">
            <t-checkbox
              v-for="filter in filters"
              :key="filter.value"
              :label="filter.value"
            >{{ filter.text }}</t-checkbox>
          </t-checkbox-group>
        </t-scroll-spy>
      </div>
      <div :class="prefixTableClass+'-filter__bottom'">
        <span :class="{ 'is-disabled': filteredValue.length === 0 }"
              :disabled="filteredValue.length === 0"
              @click="handleConfirm"
        >确定</span>
        <span @click="handleReset">重置</span>
      </div>
    </div>
    <div
      v-else
      v-show="showPopper"
      v-clickoutside="handleOutsideClick"
      :class="prefixTableClass+'-filter'"
    >
      <ul :class="prefixTableClass+'-filter__list'">
        <li
          :class="[prefixTableClass+'-filter__list-item', { 'is-active': filterValue === undefined || filterValue === null }]"
          @click="handleSelect(null)"
        >{{ t('t.table.clearFilter') }}</li>
        <li v-for="filter in filters"
            :key="filter.value"
            class="t-table-filter__list-item"
            :label="filter.value"
            :class="{ 'is-active': isActive(filter) }"
            @click="handleSelect(filter.value)"
        >{{ filter.text }}</li>
      </ul>
    </div>
  </transition>
</template>

<script type="text/babel">
import { PREFIX_CLASS } from '../../utils/constants'
import Locale from '@/mixins/locale'
import clickoutside from '@/directives/click-outside'
import Dropdown from './dropdown'
import TCheckbox from '../checkbox/checkbox.vue'
import TCheckboxGroup from '../checkbox/checkbox-group.vue'
import TScrollSpy from '../scroll-spy/scroll-spy.vue'
import Popper from './vue-popper'
const PREFIX_TABLE_CLASS = `${PREFIX_CLASS}table`
export default {
  name: 'TTableFilterPanel',

  directives: {
    clickoutside
  },

  components: {
    TCheckbox,
    TCheckboxGroup,
    TScrollSpy
  },

  mixins: [Popper, Locale],

  props: {
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },

  customRender(h) {
    return (<div class="table-filter">
      <div class="table-filter__content">
      </div>
      <div class="table-filter__bottom">
        <button on-click={ this.handleConfirm }>{ this.t('el.table.confirmFilter') }</button>
        <button on-click={ this.handleReset }>{ this.t('el.table.resetFilter') }</button>
      </div>
    </div>)
  },

  data() {
    return {
      table: null,
      cell: null,
      column: null,
      prefixTableClass: PREFIX_TABLE_CLASS
    }
  },

  computed: {
    filters() {
      return this.column && this.column.filters
    },

    filterValue: {
      get() {
        return (this.column.filteredValue || [])[0]
      },
      set(value) {
        if (this.filteredValue) {
          if ((typeof value !== 'undefined') && (value !== null)) {
            this.filteredValue.splice(0, 1, value)
          } else {
            this.filteredValue.splice(0, 1)
          }
        }
      }
    },

    filteredValue: {
      get() {
        if (this.column) {
          return this.column.filteredValue || []
        }
        return []
      },
      set(value) {
        if (this.column) {
          this.column.filteredValue = value
        }
      }
    },

    multiple() {
      if (this.column) {
        return this.column.filterMultiple
      }
      return true
    }
  },
  watch: {
    showPopper(val) {
    }
  },

  mounted() {
    this.popperElm = this.$el
    this.referenceElm = this.cell
    this.table.bodyWrapper.addEventListener('scroll', () => {
      this.updatePopper()
    })

    this.$watch('showPopper', (value) => {
      if (this.column) this.column.filterOpened = value
      if (value) {
        Dropdown.open(this)
      } else {
        Dropdown.close(this)
      }
    })
  },

  methods: {
    isActive(filter) {
      return filter.value === this.filterValue
    },

    handleOutsideClick() {
      setTimeout(() => {
        this.showPopper = false
      }, 16)
    },

    handleConfirm() {
      this.confirmFilter(this.filteredValue)
      this.handleOutsideClick()
    },

    handleReset() {
      this.filteredValue = []
      this.confirmFilter(this.filteredValue)
      this.handleOutsideClick()
    },

    handleSelect(filterValue) {
      this.filterValue = filterValue

      if ((typeof filterValue !== 'undefined') && (filterValue !== null)) {
        this.confirmFilter(this.filteredValue)
      } else {
        this.confirmFilter([])
      }

      this.handleOutsideClick()
    },

    confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      })
      this.table.store.updateAllSelected()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/table/filter-panel.vue